export const headers = [
    { value: "Mes" },
    { value: "No. de cortes cerrados" },
    { value: "Ingresos" },
    { value: "Gastos" },
    { value: "Utilidad" },
    { value: "Incidencias" },
    { value: "Acciones" },
]
